<template>
  <v-timeline>
    <v-timeline-item
      v-for="negociacao in negociacoes"
      :key="negociacao.id"
      :right="isComprador(negociacao)"
      :left="!isComprador(negociacao)"
      :color="color(negociacao)"
    >
      <span slot="opposite">{{ negociacao.createdIn | dateDescription }}</span>
      <px-negociacao-solicitacao-card :negociacao="negociacao"
                                      :resposta="resposta"
                                      :is-comprador="isComprador(negociacao)"/>
    </v-timeline-item>
  </v-timeline>
</template>

<script>
import { TipoNegociacao } from 'px-business-components';
import NegociacaoSolicitacaoCard from '../diff/NegociacaoSolicitacaoCard.vue';

export default {
  props: {
    negociacoes: Array,
    resposta: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isComprador() {
      return negociacao => negociacao.tipo === TipoNegociacao.keys.SOLICITACAO.key;
    },
    color() {
      return (negociacao) => {
        if (this.isComprador(negociacao)) {
          return 'warning';
        }
        return 'primary';
      };
    },
  },
  components: {
    pxNegociacaoSolicitacaoCard: NegociacaoSolicitacaoCard,
  },
};
</script>
